export function initCarousels() {
    let carousels = $(".carousel");

    for (let i = 0; i < carousels.length; i++) {
        let carousel = carousels[i];

        $("#" + carousel.id).on('slide.bs.carousel', function (e) {
            if (e.type === "slide" && !$(this).hasClass("fully-loaded")) {
                let images = $(this).find(".carousel-image");

                for (let j = 0; j < images.length; j++) {
                    let image = images[j];
                    image.src = image.dataset.image;
                }

                $(this).addClass("fully-loaded");
                console.log("loaded additional images " + carousel.id);
            }
        })
    }
}

